class TowMagicService {
  /**
   * @param {{
   * postApprovalEventRecordId: number
      * dispatchId: string
      * providerId: string
      * motorClubShortName: string
      * [remarks]: string
      * updateType: string
      * [notes]: string
      * approved: boolean
      * updatedEta: number
      * [responseCode]: string
      * digitalProviderNetwork: string
      * dispatchHasPayment: bool
      * }}
      * @returns {Promise<AxiosResponse>}
     */

  static mapPostApprovalEventResponsePayload({
    postApprovalEventRecordId,
    dispatchId,
    providerId,
    motorClubShortName,
    remarks,
    updateType,
    notes,
    approved,
    updatedEta,
    responseCode,
    digitalProviderNetwork,
    dispatchHasPayment
  }) {
    return {
      postApprovalEventRecordId,
      dispatchId: Number(dispatchId),
      providerId: Number(providerId),
      motorClubShortName,
      remarks,
      updateType,
      notes,
      approved,
      updatedEta,
      responseCode,
      digitalProviderNetwork,
      dispatchHasPayment
    };
  }
}

export default TowMagicService;
